export enum ArchivoEstado {
  NUEVO = 0,
  CONFIRMADO = 1,
  PROCESANDO = 2,
  ERROR = 5,
  ANULADO = 99,
  TERMINADO = 100,
}